<!--~
~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
<dash-gis-flexible-panel panelTitle="Line Isolation" (closePanel)="close()">
    <div class="isolation-list-container">
        <div>
            <div>
                <h2 class="mat-h2">Selected Lines</h2>
                <div class="item-list">
                    @for (line of selectedLines(); track line) {
                        <span>{{ line }}</span>
                    }
                </div>
            </div>
            <div>
                <h2 class="mat-h2">Valves</h2>
                <div class="item-list">
                    @for (node of isolatedNodes(); track node) {
                        <span>{{ node }}</span>
                    }
                </div>
            </div>
            <div>
                <h2 class="mat-h2">Lines Affected</h2>
                <div class="item-list">
                    @for (line of isolatedLines(); track line) {
                        <span>{{ line }}</span>
                    }
                </div>
            </div>
            @if (parcelsIncluded) {
                <div>
                    <h2 class="mat-h2">Parcels Affected</h2>
                    <div class="item-list">
                        @for (parcel of isolatedParcels(); track parcel) {
                            <span>{{ parcel }}</span>
                        }
                    </div>
                </div>
            }
        </div>
        <div>
            <button mat-button (click)="selectFeatures()">Select Highlighted</button>
        </div>
    </div>
</dash-gis-flexible-panel>
